import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Grid, Box, Link } from '@mui/material';

function PopulationStatistique() {
  return (
    <div style={{ backgroundColor: '#e3f2fd', paddingBottom: '40px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
        <Typography variant="h4" align="justify" gutterBottom sx={{ color: '#388E3C', fontWeight: 'bold' }}>
           Statistiques de la Population
        </Typography>
        <Box sx={{ backgroundColor: '#ffffff', padding: 3, borderRadius: 2, boxShadow: 1 }}>
          <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Publication récente
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Population actuelle :</strong> 12,332,788
                <br />
                <Link href="/resultatRGPHAE2024" target="_blank" sx={{ color: '#00A3E0', fontSize:'0.8rem' }}>
                  Voir plus sur les Résultats du RGPAE - Édition 2024
                </Link>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Informations Clés
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Population totale (2024):</strong> 13,353,051
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Taux de croissance (2024):</strong> 1.95%
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                <strong>Densité (2024):</strong> 480 hab/km²
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333',fontSize: '12px' }}>
                <strong>Source:</strong> 
                <Link href="/documents/rapports/Rapport_Projections-_2016.pdf" target="_blank" sx={{ color: '#00A3E0', fontWeight: 'bold' }}>
                  Projection démographique 2010-2050
                </Link>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Perspectives
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                Selon les scénarios de prévalence contraceptive, la population pourrait atteindre entre <strong>18,4 et 22,2 millions</strong> d'ici 2050.
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography variant="h6" align="left" gutterBottom sx={{ color: '#388E3C' }}>
                Historique
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                - 1990: <strong>5,292,793</strong> (RGPH)
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                - 2008: <strong>8,053,574</strong> (RGPH)
              </Typography>
              <Typography variant="body1" align="left" paragraph sx={{ color: '#333' }}>
                - 2024: <strong>12,332,788</strong>(RGPHAE 2024)
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <Footer />
    </div>
  );
}

export default PopulationStatistique;